import classNames from 'classnames';
import React, { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { createUseStyles } from 'react-jss';
import tinycolor from 'tinycolor2';
import { EmptyButtons } from '../../components/empty/empty-buttons';
import { EmptyCongratulationsAnimated } from '../../components/empty/empty-congratulations-animated';
import { useStorage } from '../../hooks/use-storage';
import { layoutDefaults } from '../../utils/layout-defaults';
import { parseContainerBackgroundImage } from '../../utils/manager/layout-manager';
import { publicResources } from '../../utils/public-resources';
import { useEmptyAssignModal } from './empty-assign-modal';
import { useNewMenuModal } from './new-menu-modal';

const animateFromLeft =
  'animate__animated animate__fadeInLeft animate__delay-1s';
const animateFromRight =
  'animate__animated animate__fadeInRight animate__delay-1s';

const animateToLeft = 'animate__animated animate__fadeOutLeft animate__faster';
const animateToRight =
  'animate__animated animate__fadeOutRight animate__faster';

function EmptyQRCodeFirstScreen({ batch, onAppDownloadClick }) {
  const { showingModal } = useStorage();
  const { t } = useTranslation();
  const [, showEmptyAssignModal] = useEmptyAssignModal({
    onAppDownloadClick,
  });
  const [, showNewMenuModal] = useNewMenuModal({
    onAppDownloadClick,
  });
  const [loaded, setLoaded] = useState(false);
  const classes = useStyles();

  useEffect(() => {
    setLoaded(true);
  }, []);

  const animateClassLeft = useMemo(
    () => (showingModal ? animateToLeft : animateFromLeft),
    [showingModal]
  );

  const animateClassRight = useMemo(
    () => (showingModal ? animateToRight : animateFromRight),
    [showingModal]
  );

  const onAssignClick = () => {
    showEmptyAssignModal();
  };

  const onNewClick = () => {
    showNewMenuModal();
  };

  return (
    <div className={classes.container}>
      <EmptyCongratulationsAnimated />

      <div className={classes.centerContainer}>
        <span
          className={classNames(classes.spots, animateClassLeft)}
          style={{ '--animate-delay': loaded ? '0.5s' : '1.3s' }}
        >
          {t('empty-qrcode-first.tables')}
          <b>
            <b>
              {batch.spot_number_first} à {batch.spot_number_last}
            </b>
          </b>
        </span>
        <span
          className={classNames(classes.batch, animateClassRight)}
          style={{ '--animate-delay': '1.4s' }}
        >
          LOT.
          <b>E{batch.code}</b>
        </span>
      </div>

      <EmptyButtons onAssignClick={onAssignClick} onNewClick={onNewClick} />
    </div>
  );
}

const useStyles = createUseStyles({
  container: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',

    // alignItems: 'center',
    // justifyContent: 'center',

    height: '100vh',
    backgroundColor: layoutDefaults.buttin,
    backgroundImage: `url(${
      publicResources.image.wavesBackground
    }), ${parseContainerBackgroundImage()}`,
    backgroundRepeat: 'no-repeat no-repeat',
    backgroundPosition: 'right 0px top 0px',
    backgroundSize: '500%, 100%',

    // border: '1px solid white',
  },
  centerContainer: {
    // position: 'absolute',
    display: 'flex',
    // flex: 1,
    flexDirection: 'column',

    top: 0,
    bottom: 0,
    left: 0,
    right: 0,

    alignSelf: 'center',
    verticalAlign: 'center',
    alignItems: 'center',
    justifyContent: 'center',

    // flexGrow: 1,
    // border: '1px solid red',
  },
  spots: {
    textTransform: 'uppercase',
    fontWeight: '200',
    fontSize: layoutDefaults.bigFontSize,

    // marginTop:
    //   layoutDefaults.biggestVerticalMargin + layoutDefaults.bigVerticalMargin,
    backgroundColor: tinycolor('white').setAlpha(0.07).toRgbString(),

    paddingLeft: layoutDefaults.smallHorizontalMargin,
    paddingRight: layoutDefaults.smallHorizontalMargin,
    paddingTop: layoutDefaults.smallerVerticalMargin,
    paddingBottom: layoutDefaults.smallerVerticalMargin,
    // marginBottom: layoutDefaults.smallVerticalMargin - 4,
    marginBottom: layoutDefaults.smallerVerticalMargin + 1,

    border: '1px solid white',
    borderRadius: 4,
  },
  batch: {
    fontSize: layoutDefaults.smallFontSize,
    fontWeight: '200',
    opacity: 0.7,
  },
});

export { EmptyQRCodeFirstScreen };
